import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: number | string;
  color?: string;
  style?: object;
};
function PhotographMedium({
  size = 16,
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  return <Svg width={size} height={size} viewBox="0 0 24 24" fill={color} style={style}><path d="M13.75 12.548l-1.985-1.985h0a2.85 2.85 0 00-4.03 0h0L4.6 13.698V5.75A1.15 1.15 0 015.75 4.6h12a1.15 1.15 0 011.15 1.15v5.948l-.135-.135h0a2.85 2.85 0 00-4.03 0h0l-.985.985zm-8-9.648A2.85 2.85 0 002.9 5.75v12a2.85 2.85 0 002.85 2.85h12a2.85 2.85 0 002.85-2.85v-12a2.85 2.85 0 00-2.85-2.85h-12zM4.6 17.75v-1.648l4.337-4.337s0 0 0 0a1.15 1.15 0 011.626 0s0 0 0 0l4.586 4.586a.85.85 0 101.202-1.202l-1.399-1.399.985-.985s0 0 0 0a1.15 1.15 0 011.626 0s0 0 0 0l1.337 1.337v3.648a1.15 1.15 0 01-1.15 1.15h-12a1.15 1.15 0 01-1.15-1.15zM13.75 6.9a.85.85 0 000 1.7h.01a.85.85 0 000-1.7h-.01z"  stroke="#000" strokeWidth={0.2} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default PhotographMedium;